<template>
    <router-view/>
</template>

<script>
    export default {
        name: "CalismaRuhsat"
    }
</script>

<style scoped>

</style>